import { Container, Box, Typography, Link } from "@mui/material";

export default function Banner() {
  return (
    <Container
      maxWidth={false}
      sx={{
        p: 0, // Remove default padding
        m: 0, // Remove default margin
        width: "100%", // Ensure full width
        "@media (min-width:600px)": {
          px: 0, // Remove padding on larger screens
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center", // Center the image horizontally
          width: "100%", // Make sure the box spans the full width
          backgroundColor: "#0f0f0f",
        }}
      >
        <img
          src="/LogoBanner.png" // Replace with your image URL
          alt="Placeholder"
          style={{
            maxWidth: "100%",
            maxHeight: "250px",
            height: "auto",
            borderRadius: "0px",
          }} // Ensure the image scales properly
        />
      </Box>
    </Container>
  );
}
